import { render, staticRenderFns } from "./downloadHistory.vue?vue&type=template&id=a59d155a&scoped=true&"
import script from "./downloadHistory.vue?vue&type=script&lang=js&"
export * from "./downloadHistory.vue?vue&type=script&lang=js&"
import style0 from "./downloadHistory.vue?vue&type=style&index=0&id=a59d155a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59d155a",
  null
  
)

component.options.__file = "downloadHistory.vue"
export default component.exports